import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Button from "components/Button";
import type { ButtonProps } from "components/Button/Button";
import { composeEventHandlers } from "utils";
import useCarousel from "../hooks/useCarousel";
import useCarouselActions from "../hooks/useCarouselActions";

export interface CarouselNextButtonProps extends ButtonProps {}

/**
 * @description Shows the following slide. Reads "Next" unless children are given.
 * Calling `preventDefault` in `onClick` keeps the current slide.
 */
function CarouselNextButton(props: CarouselNextButtonProps) {
  const { onClick, children, ...rest } = props;

  const { t } = useTranslation();
  const { slidesId } = useCarousel();
  const { next } = useCarouselActions();

  const handleOnClick = useMemo(() => composeEventHandlers(onClick, next), [onClick, next]);

  return (
    <Button aria-controls={slidesId} {...rest} onClick={handleOnClick}>
      {children ?? t("global.next_button_text")}
    </Button>
  );
}

export default CarouselNextButton;
